// Order a set of SizeOptions rows by SortOrder (nulls last), then natural/numeric
// by value. Returns the size value strings.
function orderRows(rows) {
  const out = rows
    .map((r) => ({
      value: String(r?.SizeOption ?? '').trim(),
      sortOrder: r?.SortOrder == null || r?.SortOrder === '' ? null : Number(r.SortOrder),
    }))
    .filter((r) => Boolean(r.value));

  out.sort((a, b) => {
    const ao = a.sortOrder;
    const bo = b.sortOrder;
    const aHas = Number.isFinite(ao);
    const bHas = Number.isFinite(bo);
    if (aHas && bHas) return ao - bo;
    if (aHas && !bHas) return -1;
    if (!aHas && bHas) return 1;
    return a.value.localeCompare(b.value, undefined, { sensitivity: 'base', numeric: true });
  });

  return out.map((r) => r.value);
}

/**
 * Ordered size values for a commodity, optionally scoped to a Domestic/Import origin.
 *
 *   originType omitted/empty → every size for the commodity (legacy behavior).
 *   originType 'Domestic'    → Domestic sizes only.
 *   originType 'Import'      → Import sizes if the commodity has any, else Domestic
 *                              (a commodity always has at least Domestic sizes).
 *
 * Rows with no OriginType read as 'Domestic'. Ordering is by SortOrder (which the
 * backend maintains per (commodity, origin)), nulls last, then natural/numeric.
 */
export function getOrderedSizesForCommodity(sizeOptionRows, commodityUniqueId, originType) {
  const cid = Number(commodityUniqueId);
  if (!Number.isFinite(cid) || cid <= 0) return [];

  const rows = (Array.isArray(sizeOptionRows) ? sizeOptionRows : [])
    .filter((r) => Number(r?.CommodityUniqueID) === cid);

  if (originType == null || originType === '') return orderRows(rows);

  const importRows = rows.filter((r) => String(r?.OriginType || 'Domestic') === 'Import');
  const domesticRows = rows.filter((r) => String(r?.OriginType || 'Domestic') !== 'Import');

  if (String(originType) === 'Import') {
    return orderRows(importRows.length ? importRows : domesticRows);
  }
  return orderRows(domesticRows);
}
